import { Text } from "dash-styled"
import { SchemaFormModal } from "./SchemaFormModal"

type DeleteModalProps = {
    testId?: string
    onClose: () => void
    onSubmit: () => void
}

export const SchemaFormDeleteModal = ({
    testId,
    onClose,
    onSubmit
}: DeleteModalProps) => {
    const handleDelete = () => {
        onSubmit()
        onClose()
    }

    return (
        <SchemaFormModal
            type="warn"
            title="Are you sure you want to delete this?"
            onClose={onClose}
            onSubmit={handleDelete}
            testId={testId}
            submit={{
                label: "Delete"
            }}
        >
            <Text>This action can't be undone</Text>
        </SchemaFormModal>
    )
}
